import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

const VERSION_KEY = 'app-version';

@Injectable({ providedIn: 'root' })
export class VersionService {
  constructor(private http: HttpClient) {}

  check(): void {
    this.http.get<{ version: string }>(`${environment.apiUrl}/version`).subscribe({
      next: ({ version }) => {
        const stored = localStorage.getItem(VERSION_KEY);
        if (stored !== version) {
          localStorage.setItem(VERSION_KEY, version);
          const url = new URL(window.location.href);
          url.searchParams.set('v', version);
          window.location.replace(url.toString());
        }
      },
      error: () => {}
    });
  }

  getApiVersion(): Observable<string> {
    return this.http.get<{ version: string }>(`${environment.apiUrl}/version`).pipe(
      map(r => r.version)
    );
  }

  getStoredVersion(): string {
    return localStorage.getItem(VERSION_KEY) ?? 'not set';
  }
}
